import {
  UpdateNoReturnResponse,
  GpxResponse,
  CreateGpxEntryRequestBody,
} from '@digimap/types/api'
import apiFetch from './apiFetch'

export async function createGpxEntry(payload: CreateGpxEntryRequestBody) {
  return await apiFetch<CreateGpxEntryRequestBody, UpdateNoReturnResponse>(
    `gpx`,
    'POST',
    payload
  )
}

export async function fetchAllGpxFiles() {
  return await apiFetch<void, GpxResponse>(`gpx`, 'GET')
}
